import React from 'react';
import { connect } from 'redux-bundler-react';

const mapfileMatcher = /m\.\w+\/\w+/g;

class LegendItem extends React.Component {
  constructor(props){
    super(props);
    const { displayName, url } = props.layer;
    const { apiRoot } = props;
    const mapfile = url.match(mapfileMatcher)[0]
    this.state = {
      displayName: displayName,
      src: `${apiRoot}/tiles/legend/${mapfile}.png`
    }
  }


  render(){
    const { src, displayName } = this.state;
    return (
      <li className="list-group-item">
        <div className="overflow-ellipsis" title={ displayName }><strong>{ displayName }</strong></div>
        <img alt={`Example of style for ${ displayName }`} src={ src }></img>
      </li>
    )
  }
}

export default connect(
  'selectApiRoot',
  LegendItem
);